export default __webpack_public_path__ + "static/media/p2-5.94755000.png";